module.exports = __webpack_public_path__ + "img/leader1.8cbe1f3b.jpg";